'use strict';

var $ = window.jQuery;

$.extend($.expr[':'], {
  valueEmpty: function (event) {
    return $(event).val() === '' && event.value === '';
  }
});

$('.js-suggested-competitor-button').on('click', function (event) {
  var competitorValue;
  var $input;
  var $this = $(this);
  var value = $this.attr('data-value');
  var $inputsAvailable = $('.js-competitor-input:valueEmpty');

  event.preventDefault();

  if ($inputsAvailable.length < 2) {
    $('.js-suggested-competitor-container').fadeOut();
  }

  if ($inputsAvailable.length > 0) {
    $input = $inputsAvailable.first();
    competitorValue = $input.val();

    if ((competitorValue != null) || competitorValue === '') {
      $this.parent('.tag').addClass('hidden');
      return $input.val(value);
    }
  }
});
